// Find variant based on selected options
function findVariantByOptions(selectedOptions) {
  const variants = window.stickyBarProductData.variants;
  
  return variants.find(variant => {
    return selectedOptions.every((value, index) => {
      return variant.options[index] === value;
    });
  });
}

// Update variant when any dropdown changes
function updateVariantSticky() {
  const selects = document.querySelectorAll('.matc-variantsSelecter');
  const selectedOptions = [];
  
  selects.forEach(select => {
    if (select.value && select.value !== '') {
      selectedOptions.push(select.value);
    }
  });
  
  // Only try to find variant if we have all selections
  if (selectedOptions.length === selects.length) {
    const variant = findVariantByOptions(selectedOptions);
    
    if (variant) {
      // Store current variant ID
      window.currentStickyVariantId = variant.id;
      
      // Update button state based on availability
      const addToCartBtn = document.getElementById('matc-add-to-cart-btn');
      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          const btnText = addToCartBtn.querySelector('span');
          if (btnText && btnText.dataset.defaultText) {
            btnText.textContent = btnText.dataset.defaultText;
          }
        } else {
          addToCartBtn.disabled = true;
          const btnText = addToCartBtn.querySelector('span');
          if (btnText) {
            btnText.textContent = 'Sold Out';
          }
        }
      }
    }
  }
}

function addToCartStickyBar() {
  let variantId = window.currentStickyVariantId;
  
  // If no variant selected, use the first available variant
  if (!variantId && window.stickyBarProductData) {
    const firstAvailableVariant = window.stickyBarProductData.variants.find(v => v.available);
    if (firstAvailableVariant) {
      variantId = firstAvailableVariant.id;
    } else {
      // If no available variants, use the first variant
      variantId = window.stickyBarProductData.variants[0]?.id;
    }
  }
  
  if (!variantId) {
    console.error('No variant available');
    return;
  }
  
  const formData = {
    quantity: 1,
    id: parseInt(variantId)
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData)
  })
  .then((response) => response.json())
  .then((product) => {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        if (window.SLIDECART_UPDATE) {
          window.SLIDECART_UPDATE(cart);
        }
        if (window.SLIDECART_OPEN) {
          window.SLIDECART_OPEN();
        }
        document.getElementById('cstm-sticky-bar')?.classList.remove('mvisible');
      });
  })
  .catch((e) => {
    console.error('Add to cart failed:', e);
  });
}

function isElementMovedUpAndOutOfViewport(el) {
  if (!el) return false;
  var rect = el.getBoundingClientRect();
  return (rect.bottom <= 0 && rect.top < window.innerHeight);
}

function isElementInViewport(el) {
  if (!el) return false;
  var rect = el.getBoundingClientRect();
  return (rect.top < window.innerHeight && rect.bottom > 0);
}

function checkVisibility() {
  let ogPaymentElement = document.querySelector(".og-payment");
  let stickyatc = document.querySelector("#cstm-sticky-bar");
  let footer = document.querySelector("footer");

  if (!stickyatc) return;

  if (footer && isElementInViewport(footer)) {
      stickyatc.classList.remove("mvisible");
      return;
  }

  if (ogPaymentElement && isElementMovedUpAndOutOfViewport(ogPaymentElement)) {
      stickyatc.classList.add("mvisible");
  } else {
      stickyatc.classList.remove("mvisible");
  }
}  

// Event listeners
window.addEventListener("scroll", checkVisibility);
window.addEventListener("resize", checkVisibility);

// Initialize on load
document.addEventListener('DOMContentLoaded', function() {
  checkVisibility();
});

// Also run immediately in case DOM is already loaded
if (document.readyState === 'loading') {
  // Still loading, wait for DOMContentLoaded
} else {
  // DOM already loaded
  checkVisibility();
}

function checkVisibilitybtn() {
  let ogproductform = document.querySelector(".add-to-cart");
  let stickyatc = document.querySelector("#m-back-to-top");
  if (isElementMovedUpAndOutOfViewport(ogproductform)) {
      stickyatc.classList.add("mvisible");
  } else {
      stickyatc.classList.remove("mvisible");
  }
}  

document.querySelector("#m-back-to-top")?.addEventListener("click", function(e) {
  let ogproductform = document.querySelector(".uproductform");
  if (ogproductform) {
    ogproductform.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
});

window.addEventListener("scroll", checkVisibilitybtn);
window.addEventListener("resize", checkVisibilitybtn);
checkVisibilitybtn();


  function updateShippingDate() {
const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    
    const formattedDate = `${daysOfWeek[tomorrow.getDay()]}, ${tomorrow.getDate()} ${months[tomorrow.getMonth()]}`;
    document.getElementById('mshipping-date').innerText = formattedDate;
    
    const msUntilMidnight = new Date(now.setHours(24, 0, 0, 0)) - now;
    setTimeout(() => {
        updateShippingDate();
        setInterval(updateShippingDate, 24 * 60 * 60 * 1000);
    }, msUntilMidnight);
}